export enum PaymentType {
  PENALTY = 'penalty',
  PAYOUT = 'payout',
}
